<template>
  <div class="wrapper" :style="{ maxWidth: maxWidth }">
    <v-select
      item-text="label"
      item-value="value"
      :items="data"
      outlined
      v-model="value"
      return-object
      @change="onChangeStatus"
      hide-details
      :placeholder="placeholder"
      dense
      class="text"
    >
      <template v-slot:item="{ item }">
        <div :class="`${item.color}--text`">{{ item.label }}</div>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    placeholder: {
      type: String,
      default: 'Chọn TT'
    },
    value: Object,
    maxWidth: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      data: []
    }
  },
  created() {
    if (this.items && this.items.length) {
      this.data = this.items.map(i => {
        return { label: i.label, value: i.value, color: i.color || '' }
      })
      this.data.unshift({ label: 'Tất cả', value: '', color: 'primary' })
    }
  },
  methods: {
    onChangeStatus(status) {
      this.$emit('onChangeStatus', status.value)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-text-field .v-input__control {
    color: inherit;
    height: 28px;
    background-color: white !important;
  }
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
    padding: 0 8px;
    height: 28px;
  }
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
    > .v-input__control
    > .v-input__slot
    fieldset {
    color: rgba(0, 0, 0, 0.38);
    height: 34px;
  }
  .v-select__slot {
    height: 28px;
  }
  .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner {
    margin-top: 4px;
  }
  .v-text-field--outlined.v-input--is-focused fieldset {
    height: 32px;
  }
}
.v-input--selection-controls .v-input__slot {
  color: inherit !important;
}
.v-text-field--outlined > .v-input__control > .v-input__slot {
  background-color: white;
}
</style>
